<template>
  <figure
    v-if="data.image"
    class="kpb-image"
    :style="`--kpb-image-object-fit: ${objectFit}; --kpb-image-object-position: ${objectPosition}; --kpb-image-aspect-ratio: ${aspectRatio};`"
  >
    <img class="kpb-image__image" :src="data.image.url" :alt="data.image.alt || ''" />
    <figcaption v-if="data.image.description" class="kpb-image__caption">{{ data.image.description }}</figcaption>
  </figure>
</template>

<script>
/** Component for rendering images */
export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        image: {},
      }),
    },
    aspectRatio: String,
    objectFit: {
      type: String,
      default: 'cover',
    },
    objectPosition: {
      type: String,
      default: 'center',
    },
  },
}
</script>

<style lang="scss">
.kpb-image {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  aspect-ratio: var(--kpb-image-aspect-ratio);

  &__image {
    flex-grow: 1;
    width: 100%;
    background-color: rgba(black, 0.2);
    object-fit: var(--kpb-image-object-fit);
    object-position: var(--kpb-image-object-position);
  }
}
</style>
